import { FlowId } from "@shared/praxis-config";
import { FlowDefinition } from "./types";

const flowLoaders = {
  standard: () => import("./standard"),
  bodybalance: () => import("./bodybalance"),
} satisfies Record<FlowId, () => Promise<{ default: FlowDefinition }>>;

export const loadFlow = async (flowId: FlowId): Promise<FlowDefinition> => {
  const module = await flowLoaders[flowId]();
  return module.default;
};
